import AuthService from "../login/auth.service";
import { basaSipacoop, comprobantes, dimo } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class ReimpresionXpressService {
  async reimprimirLista(cedula, mes) {
    var data = JSON.stringify({ cedula: cedula, mes: mes });
    var config = {
      method: "post",
      url: dimo + "reimprimir/transferenciaXpress",
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descargarComponente(data){

    var _url = comprobantes + "comprobantes/v2/reimpresion/transferencias-xpress"; 
    var config = {
      method: "POST",
      url: _url,
      data: data,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }


}
export default new ReimpresionXpressService();
